module.exports = __webpack_public_path__ + "9fd450a94c2417388faf5332ccac26bf.fbx";